import Env from '../base/env';
import Component from 'gia/Component';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
import { SplitText } from '../vendor/gsap-bonus-umd/SplitText';
import easesCustom from '../fx/CustomEases';
gsap.registerPlugin(ScrollTrigger,SplitText);

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.title = this.DOM.view.querySelectorAll('.fxTitle')
    this.DOM.desc = this.DOM.view.querySelectorAll('.fxDesc')
    this.DOM.bullet = this.DOM.view.querySelector('.fxBullet')
    //! Vars
    setTimeout(() => {
      this._fx()
    }, Env.timingDelayFx);
  }

  _fx()
  {
    this.animate()
    this.reveal()
  }

  animate()
  {
    this.animation = gsap.timeline()
    this.animation.add([
      gsap.fromTo(
        this.DOM.title,
        {
          y:'130%'
        },
        {
          y:0,
          ease:easesCustom.quart,
          duration:.7,
          stagger:.15,
          onComplete:()=>{
            for(let title of this.DOM.title) {
              title.parentElement.classList.remove('tw-overflow-hidden')
            }
          }
        }
      ),
    ])
    .add([
      gsap.fromTo(
        this.DOM.bullet,
        {
          scale:0
        },
        {
          scale:1,
          ease:'quint.inOut',
          duration:.8
        }
      ),
      gsap.fromTo(
        this.DOM.desc,
        {
          autoAlpha:0
        },
        {
          autoAlpha:1,
          ease:'cubic.inOut',
          duration:1.2,
          stagger:.25
        }
      )
    ])
  }

  reveal()
  {
    const offsetStart = (Env.mobileCSS)?'top 80%':'top 60%';
    this.st = ScrollTrigger.create({
      animation:this.animation,
      trigger:this.DOM.view,
      start:offsetStart
    })
  }

  unmount()
  {
    this.st.kill()
  }
}
